export function getAllAgreements(axiosPrivate) {
  return axiosPrivate.get('/trade-data-agreement/list-agreements')
}

export function deleteAgreement(axiosPrivate, id) {
  return axiosPrivate.delete(`/trade-data-agreement/${id}/delete`)
}

export function exportAllAgreements(axiosPrivate) {
  return axiosPrivate.post('/trade-data-agreement/export-agreements')
}
